export const TextTemplateSpecialCharacters = [".", ",", ":", ";", "!", "?"]
